// extracted by mini-css-extract-plugin
export default {"section":"tr-z","inSectionButton":"ur-z","addressCard":"vr-z","disabled":"wr-z","cautionBox":"xr-z","failureBox":"yr-z","fade-out":"zr-z","successBox":"Ar-z"};